/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";

import Button from "../../Button";

interface Props {
  onClose: () => void;
}

const CloseButtons: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation("consultations");

  return (
    <>
      <div className="mt-10 text-center space-x-4">
        <Button
          size="large"
          render="transparent"
          onClick={() => onClose()}
        >
          <span>{t("common:close")}</span>
        </Button>
        <Link href="/my-queues">
          <Button
            size="medium"
            render="primary"
            onClick={() => onClose()}
          >
            <span>{t("consultationForm.viewQueue")}</span>
          </Button>
        </Link>
      </div>
    </>
  );
};

export default CloseButtons;
